import { render, staticRenderFns } from "./AddPosition.vue?vue&type=template&id=3832e2e9&"
import script from "./AddPosition.vue?vue&type=script&lang=js&"
export * from "./AddPosition.vue?vue&type=script&lang=js&"
import style0 from "./AddPosition.vue?vue&type=style&index=0&id=3832e2e9&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports